module.exports = __webpack_public_path__ + "images/psp/PSPHero/24-hour-hero.webp";